import { render, staticRenderFns } from "./DialogEditFolderSearch.vue?vue&type=template&id=79f07c8a"
import script from "./DialogEditFolderSearch.vue?vue&type=script&lang=js"
export * from "./DialogEditFolderSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports